<template lang='pug'>
  div(class='pie-chart' )
</template>
<script>
// 引入基本模板
import echarts from 'echarts/lib/echarts'
// 引入雷达图组件
import 'echarts/lib/chart/pie'
// 引入提示框和图例组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/graphic'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
  props: {
    cateCount: Array
  },

  /**
   * 圓餅圖的參數:
   * a（系列名稱)
   * b（數據項名稱）
   * c（數值）
   * d（百分比）
   */
  data () {
    return {
      echarts,
      pieChart: null,
      option: {
        title: {
          zlevel: 0,
          text: ['{value|2000}', '{name|件}'].join(''),
          top: '44%',
          left: '50%',
          textAlign: 'center',
          textStyle: {
            rich: {
              value: {
                color: '#7E7E7E',
                fontSize: 20,
                fontWeight: 'bold'
              },
              name: {
                color: '#7E7E7E'
              }
            }
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: ['{b}'].join('')

        },
        series: [
          {
            zlevel: 1,
            type: 'pie', // 必須
            radius: ['65%', '80%'],
            stillShowZeroSum: true,
            roundCap: 1,
            itemStyle: {
              normal: {
                // borderWidth: 1,
                // borderColor: '#444444'
              }
            },
            label: {
              normal: {
                show: false,
                position: 'center',
                width: 75,
                backgroundColor: '#fff',
                formatter: [['{amount|{c}}', '{unit|件}'].join(''), '{percentage|({d}%)}'].join('\n'),
                rich: {
                  amount: {
                    fontSize: 20,
                    fontWeight: 'bold'
                  },
                  unit: {
                    fontSize: 14,
                    fontWeight: 'bold'
                  }
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              }
            },

            /**
             * 類似css的margin，由於tooltip超過Canvas Size時會被切除，因此設至此margin來避免
             *  */
            /**
             * 關閉預設的放大動畫
             */
            hoverAnimation: false,
            data: [
              { name: '紙類', value: 0 },
              { name: '鐵鋁罐', value: 0 },
              { name: '塑膠', value: 0 },
              { name: '廢棄物', value: 1 }
            ],
            color: ['#189f96', '#5adfff', '#ff6e6e', '#dddddd']
          }
        ]
      }
    }
  },

  watch: {
    cateCount () {
      let total = this.cateCount.reduce((acc, curr) => acc + curr)
      this.option.series[0].data = [
        { name: '紙類', value: this.cateCount[0] },
        { name: '鐵鋁罐', value: this.cateCount[1] },
        { name: '塑膠', value: this.cateCount[2] },
        { name: '廢棄物', value: this.cateCount[3] }
      ]
      this.option.title.text = ['{value|' + total + '}', '{name|件}'].join('')
      this.pieChart = this.echarts.init(document.getElementsByClassName('pie-chart')[0])
      this.pieChart.setOption(this.option)
    }
  }
}
</script>

<style scoped lang='scss'>
@import "@/assets/scss/helper/variables.scss";

.pie-chart {
  height: 100%;
}
</style>
